<template>
    <div>
        <div class="container h-100">
            <div class="d-flex justify-content-center h-100 valign">
                <div class="user_card" style="box-shadow: none;width: 500px;">
                    <div class="d-flex justify-content-center">
                        <div class="brand_logo_container">
                            <img src="~@/assets/images/login-logo.png" class="brand_logo" alt="Logo">
                        </div>
                    </div>
                    <!-- <div class="d-flex justify-content-center">
                        
                    </div> -->
                    <div class="d-flex justify-content-center form_container">
                        <form>
                            <h4 style="text-align: center; margin-bottom: 15px;">Reject Note</h4>
                            <div class="input-group mb-3" style="width: 350px;">
                                <textarea class="form__input" v-model.trim="internalNote" rows="2" placeholder="Internal note tiket. Contoh :Tiket dihandle oleh Susi. Perlu komunikasikan jadwal dengan client"/>
                                <!-- <input type="text" name="email" class="form-control input_user" value="" placeholder="email" v-model="email"> -->
                            </div>
                        </form>
                    </div>
                    <div class="d-flex justify-content-center mt-2 login_container">
                        <button type="button" name="button" class="btn login_btn" v-if="!onProcess" @click="rejectChange()" style="width: 350px;">Submit</button>
                        <button type="button" name="button" class="btn login_btn" v-else disabled="" style="width: 350px;"><img src="~@/assets/images/load-button.gif"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from "sweetalert";
    export default {
        name: "rejectProductAdjustment",
        data() {
            return {
                spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
                onProccess: false,
                isSuccess : null,
                internalNote : '',
            };
        },
        methods: {
            toPage(e) {
                this.$router.push(e);
            },
            showResult() {
                if(this.isSuccess !== null) {
                    if(this.isSuccess) {
                        swal({
                            title: 'Success', 
                            text: 'Berhasil', 
                            icon: 'success',
                            closeOnEsc: false,
                            allowOutsideClick: false,
                        }).then(() => {
                            this.toPage('/')
                        });
                    } else {
                        swal('Failed', 'Gagal', 'error').then(() => {
                            this.toPage('/')
                        });
                    }
                } 
            },
            rejectChange() {
                this.onProcess = true
               
                if(this.internalNote.trim().length == 0 || this.internalNote == null) {
                    swal('Sorry', 'Field must be filled', 'error')
                    this.onProcess = false
                } else {
                    const {toPage} = this
                    let location = window.location.pathname.split('/')
                    const accessToken = location[location.length - 1]
                    this.$http.post(`${process.env.REJECT_TICKET_PRODUCT_RENTING_ADJUSTMENT_EMAIL}?tokenAccess=${accessToken}`,
                        {
                            note : this.internalNote.trim().replace(this.spaceRegex, ' ')
                        },
                        {
                            headers: {'Asani-Token':localStorage.getItem('jwt')}
                        },
                    ).then(response => {
                        if (response.data.status == 400) {
                            this.isSuccess = false
                            this.showResult()
                        }else{
                            this.isSuccess = true
                            this.showResult()
                        }
                        this.onProcess = false
                    })
                    .catch(error => {
                        let message = error.message
                        if (error.response && error.response.data && error.response.data.message) {
                            message = error.response.data.message
                        }

                        swal("Sorry", message.charAt(0).toUpperCase()+ message.slice(1), "error", {
                            button: "Close",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                            this.handleLogout()
                            } else {
                                this.toPage('/')
                            }
                        })
                    })
                }
            },
            async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
                localStorage.removeItem('jwt')
                localStorage.removeItem('admin_name')
                localStorage.removeItem('roles')
                localStorage.removeItem('user_email')
                localStorage.removeItem('admin_id')
                localStorage.removeItem('changeCatalogPermission')
                this.$router.push('/')
            },
        },
        created() {
        },
        mounted() {
            // let that = this;
            // let checkGauthLoad = setInterval(function () {
            //     that.isInit = that.$gAuth.isInit;
            //     that.isSignIn = that.$gAuth.isAuthorized;
            //     if (that.isInit) clearInterval(checkGauthLoad);
            // }, 1000);
        },
    };
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    /* Coded with love by Mutiullah Samim */
    body,
    html {
      margin: 0;
      padding: 0;
      height: 100%;
      background: #60a3bc !important;
    }
    .user_card {
      height: 400px;
      width: 350px;
      margin-top: auto;
      margin-bottom: auto;
      background: #F8F9FA;
      position: relative;
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 10px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      border-radius: 5px;

    }

    .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
    }

    .brand_logo_container {
      position: absolute;
      height: 170px;
      width: 170px;
      top: -75px;
      border-radius: 50%;
      background: #fff;
      padding: 10px;
      text-align: center;
    }
    .brand_logo {
      height: 150px;
      width: 150px;
      border-radius: 50%;
      border: 2px solid white;
    }
    .form_container {
      margin-top: 40px;
    }
    .login_btn {
      width: 100%;
      background: #2797FB !important;
      color: white !important;
    }
    .login_btn:focus {
      box-shadow: none !important;
      outline: 0px !important;
    }
    .login_container {
      padding: 0 2rem;
    }
    .input-group-text {
      background: #2797FB !important;
      color: white !important;
      border: 0 !important;
      border-radius: 0.25rem 0 0 0.25rem !important;
    }
    .input_user,
    .input_pass:focus {
      box-shadow: none !important;
      outline: 0px !important;
    }
    .custom-checkbox .custom-control-input:checked~.custom-control-label::before {
      background-color: #c0392b !important;
    }

    .valign{
      vertical-align: middle;
      margin-top: 150px;
    }

    .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
    }

    @media(max-width: 991px){
      .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
      display: none;
    }
    }
    .g-sign-in-button {
            margin: 10px;
            display: inline-block;
            width: 240px;
            height: 50px;
            background-color: #4285f4;
            color: #fff;
            border-radius: 1px;
            transition: background-color .218s, border-color .218s, box-shadow .218s;
        }

        .g-sign-in-button:hover {
            cursor: pointer;
            -webkit-box-shadow: 0 0 3px 3px rgba(66, 133, 244, 0.3);
            box-shadow: 0 0 3px 3px rgba(66, 133, 244, 0.3);
        }

        .g-sign-in-button:active {
            background-color: #3367D6;
            transition: background-color 0.2s;
        }

        .g-sign-in-button .content-wrapper {
            height: 100%;
            width: 100%;
        }

        .g-sign-in-button img {
            width: 18px;
            height: 18px;
        }

        .g-sign-in-button .logo-wrapper {
            padding: 15px;
            background: #fff;
            width: 48px;
            height: 100%;
            border-radius: 1px;
            display: inline-block;
        }

        .g-sign-in-button .text-container {
            font-family: Roboto,arial,sans-serif;
            font-weight: 500;
            letter-spacing: .21px;
            font-size: 16px;
            line-height: 48px;
            vertical-align: top;
            border: none;
            display: inline-block;
            text-align: center;
            width: 280px;
        }
</style>



// WEBPACK FOOTER //
// src/components/Order/RejectProductAdjustmentPage.vue